import ListView from '../../components/listView/ListView'
import Page from '../../components/pageView/Page'
import PortalLayout from '../../pages/portal/PortalLayout'
import PortalError from '../../pages/portal/PortalError'
import PortalWelcomePage from '../../pages/portal/PortalWelcomePage'
import AcceptInvitation from '../../pages/portal/AcceptInvitation'
import AcceptJoinOrganization from '../../pages/portal/AcceptJoinOrganization'
import ResetPassword from '../../pages/portal/ResetPassword'

const portalRoutes = {
    layout: {
        path: '/portal/:token',
        element: PortalLayout,
        props: {}
    },
    children: [
        { path: 'welcome',       element: PortalWelcomePage,      props: {} },
        { path: 'invoice',       element: ListView, props: { type: 'portalInvoiceList' } },
        { path: 'invoice/:id',   element: Page,     props: { type: 'portalInvoicePage',     options: { mode: 'read', load: true } } },
        { path: 'creditNote',    element: ListView, props: { type: 'portalCreditNoteList' } },
        { path: 'creditNote/:id',element: Page,     props: { type: 'portalCreditNotePage',  options: { mode: 'read', load: true } } },
        { path: 'orders',        element: ListView, props: { type: 'portalStockReceiptList' } },
        { path: 'orders/:id',    element: Page,     props: { type: 'portalStockReceiptPage', options: { mode: 'edit', load: true } } },
        { path: 'products',      element: ListView, props: { type: 'portalProductList' } },
        { path: 'accept',        element: AcceptInvitation,       props: {} },
        { path: 'acceptJoin',    element: AcceptJoinOrganization, props: {} },
        { path: 'resetPassword', element: ResetPassword,          props: {} },
    ],
    error: {
        path: '/portal-error',
        element: PortalError,
        props: {}
    }
}

export default portalRoutes
